<ng-template [ngIf]="(createRequestStep$ | async) === 'input' && isManualFlow">
    <input id="text-input-field" (keypress)="onKeyPress($event)" (mousedown)="onMouseDown($event)" (keydown)="onkeydown($event)" (blur)="onchange()" 
        #inputShares [value]="params.value"
        [ngClass]="showIcon ? 'errorClass sdps-input sdps-input--small' : 'sdps-input sdps-input--small'" />
</ng-template>
<ng-template [ngIf]="(createRequestStep$ | async) === 'review' || (createRequestStep$ | async) === 'confirmation'">
    <p class='sharesToMoveClass textCell'>{{params.value}}</p>
</ng-template>
<span class="errorText" id="errorText">{{currentValue}}</span>
<sac-tooltip *ngIf="showIcon" [position]="position" [message]="toolTipError">
    <span class="sac-tooltip-icon"></span>
</sac-tooltip>